import { render, staticRenderFns } from "./AmazonChangePaymentButton.vue?vue&type=template&id=e2b679bc&"
import script from "./AmazonChangePaymentButton.vue?vue&type=script&lang=js&"
export * from "./AmazonChangePaymentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports